// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file kitecorp/transferify/pay/v1/one_off_purchases.proto (package kitecorp.transferify.pay.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_kitecorp_options_v1_options } from "../../../options/v1/options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file kitecorp/transferify/pay/v1/one_off_purchases.proto.
 */
export const file_kitecorp_transferify_pay_v1_one_off_purchases: GenFile = /*@__PURE__*/
  fileDesc("CjNraXRlY29ycC90cmFuc2ZlcmlmeS9wYXkvdjEvb25lX29mZl9wdXJjaGFzZXMucHJvdG8SG2tpdGVjb3JwLnRyYW5zZmVyaWZ5LnBheS52MSKhAQocQ29udmVydE9uZU9mZlB1cmNoYXNlUmVxdWVzdBITCgtwdXJjaGFzZV9pZBgBIAEoCRI9CgRraW5kGAIgASgOMi8ua2l0ZWNvcnAudHJhbnNmZXJpZnkucGF5LnYxLk9uZU9mZlB1cmNoYXNlS2luZBIVCg10ZXJtc192ZXJzaW9uGAMgASgJEhYKDmV4cGVjdGVkX21pbm9yGAQgASgDIs8BCh1Db252ZXJ0T25lT2ZmUHVyY2hhc2VSZXNwb25zZRITCgtwdXJjaGFzZV9pZBgBIAEoCRI9CgRraW5kGAIgASgOMi8ua2l0ZWNvcnAudHJhbnNmZXJpZnkucGF5LnYxLk9uZU9mZlB1cmNoYXNlS2luZBIWCg5jcmVkaXRlZF9taW5vchgDIAEoAxIQCghjdXJyZW5jeRgEIAEoCRIwCgxjb252ZXJ0ZWRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wKtMBChJPbmVPZmZQdXJjaGFzZUtpbmQSJQohT05FX09GRl9QVVJDSEFTRV9LSU5EX1VOU1BFQ0lGSUVEEAASSAoqT05FX09GRl9QVVJDSEFTRV9LSU5EX09WRVJfTElNSVRfQUxMT1dBTkNFEAEaGIK1GBRPVkVSX0xJTUlUX0FMTE9XQU5DRRJMCixPTkVfT0ZGX1BVUkNIQVNFX0tJTkRfUEVSU09OQUxJWkFUSU9OX0NSRURJVBACGhqCtRgWUEVSU09OQUxJWkFUSU9OX0NSRURJVDK2AQoVT25lT2ZmUHVyY2hhc2VTZXJ2aWNlEpwBChVDb252ZXJ0T25lT2ZmUHVyY2hhc2USOS5raXRlY29ycC50cmFuc2ZlcmlmeS5wYXkudjEuQ29udmVydE9uZU9mZlB1cmNoYXNlUmVxdWVzdBo6LmtpdGVjb3JwLnRyYW5zZmVyaWZ5LnBheS52MS5Db252ZXJ0T25lT2ZmUHVyY2hhc2VSZXNwb25zZSIMkAICirUYBQoDdXNlQkMKKWNvbS5raXRlY29ycC5jb250cmFjdHMudHJhbnNmZXJpZnkucGF5LnYxQhRPbmVPZmZQdXJjaGFzZXNQcm90b1ABYgZwcm90bzM", [file_google_protobuf_timestamp, file_kitecorp_options_v1_options]);

/**
 * The holder's press.
 *
 * @generated from message kitecorp.transferify.pay.v1.ConvertOneOffPurchaseRequest
 */
export type ConvertOneOffPurchaseRequest = Message<"kitecorp.transferify.pay.v1.ConvertOneOffPurchaseRequest"> & {
  /**
   * The purchase, as the listing's purchaseId spells it (a UUID).
   *
   * @generated from field: string purchase_id = 1;
   */
  purchaseId: string;

  /**
   * Its family, as the listing's kind names it.
   *
   * @generated from field: kitecorp.transferify.pay.v1.OneOffPurchaseKind kind = 2;
   */
  kind: OneOffPurchaseKind;

  /**
   * The Terms version the holder was shown, YYYY-MM-DD.
   *
   * @generated from field: string terms_version = 3;
   */
  termsVersion: string;

  /**
   * The amount the holder was shown (the listing's convertibleMinor), in the currency's minor units.
   *
   * @generated from field: int64 expected_minor = 4;
   */
  expectedMinor: bigint;
};

/**
 * Describes the message kitecorp.transferify.pay.v1.ConvertOneOffPurchaseRequest.
 * Use `create(ConvertOneOffPurchaseRequestSchema)` to create a new message.
 */
export const ConvertOneOffPurchaseRequestSchema: GenMessage<ConvertOneOffPurchaseRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_pay_v1_one_off_purchases, 0);

/**
 * The credit the press made, or the one it made before for a repeat.
 *
 * @generated from message kitecorp.transferify.pay.v1.ConvertOneOffPurchaseResponse
 */
export type ConvertOneOffPurchaseResponse = Message<"kitecorp.transferify.pay.v1.ConvertOneOffPurchaseResponse"> & {
  /**
   * The purchase, as the request named it.
   *
   * @generated from field: string purchase_id = 1;
   */
  purchaseId: string;

  /**
   * Its family, as the request named it.
   *
   * @generated from field: kitecorp.transferify.pay.v1.OneOffPurchaseKind kind = 2;
   */
  kind: OneOffPurchaseKind;

  /**
   * What was credited, in the currency's minor units: the expected_minor of the press that made it.
   *
   * @generated from field: int64 credited_minor = 3;
   */
  creditedMinor: bigint;

  /**
   * Lowercase ISO-4217.
   *
   * @generated from field: string currency = 4;
   */
  currency: string;

  /**
   * When the credit was made, UTC.
   *
   * @generated from field: google.protobuf.Timestamp converted_at = 5;
   */
  convertedAt?: Timestamp | undefined;
};

/**
 * Describes the message kitecorp.transferify.pay.v1.ConvertOneOffPurchaseResponse.
 * Use `create(ConvertOneOffPurchaseResponseSchema)` to create a new message.
 */
export const ConvertOneOffPurchaseResponseSchema: GenMessage<ConvertOneOffPurchaseResponse> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_pay_v1_one_off_purchases, 1);

/**
 * Which family a one-off purchase belongs to, spelled as the api's REST listing spells it.
 *
 * @generated from enum kitecorp.transferify.pay.v1.OneOffPurchaseKind
 */
export enum OneOffPurchaseKind {
  /**
   * Never sent. Present because every proto3 enum needs a zero value.
   *
   * @generated from enum value: ONE_OFF_PURCHASE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * An over-limit transfer allowance, the only kind the holder may convert.
   *
   * @generated from enum value: ONE_OFF_PURCHASE_KIND_OVER_LIMIT_ALLOWANCE = 1;
   */
  OVER_LIMIT_ALLOWANCE = 1,

  /**
   * A personalization credit; the scheduled job converts these, the press refuses them.
   *
   * @generated from enum value: ONE_OFF_PURCHASE_KIND_PERSONALIZATION_CREDIT = 2;
   */
  PERSONALIZATION_CREDIT = 2,
}

/**
 * Describes the enum kitecorp.transferify.pay.v1.OneOffPurchaseKind.
 */
export const OneOffPurchaseKindSchema: GenEnum<OneOffPurchaseKind> = /*@__PURE__*/
  enumDesc(file_kitecorp_transferify_pay_v1_one_off_purchases, 0);

/**
 * The signed-in holder's own one-off purchases.
 *
 * @generated from service kitecorp.transferify.pay.v1.OneOffPurchaseService
 */
export const OneOffPurchaseService: GenService<{
  /**
   * Turns one unused purchase of the caller's into credit toward a plan, for the amount the caller was shown
   * (kitecorp/transferify-api-service#3063). The holder's own act: the api records it with its time, the amount and
   * the Terms version the holder was shown. A repeat for a purchase this act already converted answers the same.
   *
   * @generated from rpc kitecorp.transferify.pay.v1.OneOffPurchaseService.ConvertOneOffPurchase
   */
  convertOneOffPurchase: {
    methodKind: "unary";
    input: typeof ConvertOneOffPurchaseRequestSchema;
    output: typeof ConvertOneOffPurchaseResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_kitecorp_transferify_pay_v1_one_off_purchases, 0);

